export class QuotesV3Environment {
  public static getName = () => 'benzinga-quotes-v3';
  public static getEnvironment = (env: Record<string, string>) => ({
    socketUrl: new URL(
      env['socketUrl'] ??
        'wss://data-api-pro.benzinga.com/api/v3/quotes/ws?quote_access=finage_crypto,cta_realtime,otc_realtime', //quote_access query param should be removed before hitting production (should be handled by BE)
    ),
  });
}
